import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setKeyValue, unsetKeyValue } from './actions';

export const useKeyValueStore = (key) => {
  const dispatch = useDispatch();
  const value = useSelector((state) => state.keyValueStore[key]);

  const setValue = useCallback((arg) => {
    if (typeof arg === 'function') {
      dispatch((actualDispatch, getState) => {
        const { keyValueStore: { [key]: currentValue } } = getState();
        actualDispatch(setKeyValue(key, arg(currentValue)));
      });
    } else {
      dispatch(setKeyValue(key, arg));
    }
  }, [dispatch, key]);

  const unsetValue = useCallback(() => {
    dispatch(unsetKeyValue(key));
  }, [dispatch, key]);

  return [value, setValue, unsetValue];
};
